var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepositMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 263,
    height: 211,
    viewBox: "0 0 263 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03_coins_graph_illustration 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.18,
    d: "M135.884 167.042C135.884 173.354 114.296 178.471 87.6671 178.471C61.0378 178.471 39.4505 173.354 39.4505 167.042C39.4505 160.729 61.0378 155.612 87.6671 155.612C114.296 155.612 135.884 160.729 135.884 167.042Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    opacity: 0.18,
    d: "M39.4505 167.042V158.25C39.4505 161.281 44.5304 164.188 53.5728 166.332C62.6152 168.475 74.8793 169.679 87.6671 169.679C100.455 169.679 112.719 168.475 121.761 166.332C130.804 164.188 135.884 161.281 135.884 158.25V167.042",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0.18,
    d: "M131.5 149.458C131.5 155.285 111.876 160.008 87.6671 160.008C63.4587 160.008 43.8338 155.285 43.8338 149.458C43.8338 143.632 63.4587 138.908 87.6671 138.908C111.876 138.908 131.5 143.632 131.5 149.458Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    opacity: 0.18,
    d: "M43.8338 149.458V141.546C43.8338 144.344 48.452 147.027 56.6723 149.006C64.8926 150.984 76.0418 152.096 87.6671 152.096C99.2925 152.096 110.442 150.984 118.662 149.006C126.882 147.027 131.5 144.344 131.5 141.546V149.458",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    opacity: 0.18,
    d: "M127.994 133.633C127.994 138.974 109.939 143.304 87.6671 143.304C65.3953 143.304 47.3405 138.974 47.3405 133.633C47.3405 128.292 65.3953 123.962 87.6671 123.962C109.939 123.962 127.994 128.292 127.994 133.633Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    opacity: 0.18,
    d: "M47.3405 133.633V126.6C47.3405 129.165 51.5892 131.625 59.1519 133.438C66.7146 135.252 76.9718 136.271 87.6671 136.271C98.3624 136.271 108.62 135.252 116.182 133.438C123.745 131.625 127.994 129.165 127.994 126.6V133.633",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    opacity: 0.18,
    d: "M123.61 118.687C123.61 123.543 107.518 127.479 87.6671 127.479C67.8162 127.479 51.7238 123.543 51.7238 118.687C51.7238 113.832 67.8162 109.896 87.6671 109.896C107.518 109.896 123.61 113.832 123.61 118.687Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    opacity: 0.18,
    d: "M51.7238 118.687V112.533C51.7238 114.865 55.5107 117.101 62.2514 118.75C68.992 120.399 78.1344 121.325 87.6671 121.325C97.1999 121.325 106.342 120.399 113.083 118.75C119.824 117.101 123.61 114.865 123.61 112.533V118.687",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.18,
    d: "M119.227 105.5C119.227 109.87 105.097 113.412 87.6671 113.412C70.237 113.412 56.1071 109.87 56.1071 105.5C56.1071 101.13 70.237 97.5874 87.6671 97.5874C105.097 97.5874 119.227 101.13 119.227 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.18,
    d: "M87.6671 101.983V109.017M84.1605 105.5H91.1738",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.18,
    d: "M149.033 175.833H245.467",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    opacity: 0.18,
    d: "M149.033 175.833V61.5416",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    opacity: 0.18,
    d: "M166.567 175.833V173.635M184.1 175.833V173.635M201.633 175.833V173.635M219.167 175.833V173.635M236.7 175.833V173.635",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    opacity: 0.18,
    d: "M149.033 158.25H151.225M149.033 140.667H151.225M149.033 123.083H151.225M149.033 105.5H151.225M149.033 87.9166H151.225",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    opacity: 0.18,
    d: "M153.417 167.042C168.028 161.181 179.717 152.389 188.483 140.667C197.25 128.944 206.017 117.222 214.783 105.5C223.55 93.7777 233.778 82.0555 245.467 70.3333",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.18,
    d: "M168.32 158.25C168.32 159.221 167.535 160.008 166.567 160.008C165.598 160.008 164.813 159.221 164.813 158.25C164.813 157.279 165.598 156.492 166.567 156.492C167.535 156.492 168.32 157.279 168.32 158.25Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    opacity: 0.18,
    d: "M190.237 140.667C190.237 141.638 189.452 142.425 188.483 142.425C187.515 142.425 186.73 141.638 186.73 140.667C186.73 139.696 187.515 138.908 188.483 138.908C189.452 138.908 190.237 139.696 190.237 140.667Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    opacity: 0.18,
    d: "M216.537 105.5C216.537 106.471 215.752 107.258 214.783 107.258C213.815 107.258 213.03 106.471 213.03 105.5C213.03 104.529 213.815 103.742 214.783 103.742C215.752 103.742 216.537 104.529 216.537 105.5Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    opacity: 0.18,
    d: "M247.22 70.3333C247.22 71.3044 246.435 72.0916 245.467 72.0916C244.498 72.0916 243.713 71.3044 243.713 70.3333C243.713 69.3622 244.498 68.575 245.467 68.575C246.435 68.575 247.22 69.3622 247.22 70.3333Z",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    opacity: 0.18,
    d: "M240.207 73.85L245.467 70.3333L241.96 76.4875",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    opacity: 0.18,
    d: "M153.417 167.042H245.467",
    strokeWidth: 0.482927,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#132A22"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositMobile);
export default __webpack_public_path__ + "static/media/deposit-mobile.6502ff03554e6c7564c08879ff15f2f6.svg";
export { ForwardRef as ReactComponent };